import { type DetailsPageProps } from 'app/main/components/page-layouts';

import RequestsDetailsTab from './tabs/RequestsDetailsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <RequestsDetailsTab {...props} />
	}
];

export default tabs;
